<script setup lang="ts">
  import { useI18n } from 'vue-i18n';
  import { tripBookingPage } from '@/cypaths';
  import type { ScheduleType } from '@/types/serviceRequest/serviceRequest.types';
  import ElRouterLink from '@/components/common/ElRouterLink/ElRouterLink.vue';
  import { ROUTE_NAME_BOOKING_FORM_DATED, ROUTE_NAME_BOOKING_FORM_TEMPLATE } from '@/config/routeNames';
  import BoxCard from '@/components/common/BoxCard/BoxCard.vue';
  import { CONTEXT_HELP_BOOKING_DATED_TRIP, CONTEXT_HELP_BOOKING_TEMPLATE_TRIP } from '@/config';
  import ContextualHelp from '@/components/common/ContextualHelp/ContextualHelp.vue';
  import useBookingEnabled from '@/composables/useBookingEnabled';

  defineOptions({ name: 'BookingServiceRequestType' });

  defineEmits<{
    select: [type: ScheduleType];
  }>();

  const { t } = useI18n();
  const bookingEnabled = useBookingEnabled();
</script>

<template>
  <div class="flex flex-col gap-4 md:gap-6">
    <BoxCard
      padded
      :title="t('generic.datedTrip')"
    >
      <template #help>
        <ContextualHelp :help-id="CONTEXT_HELP_BOOKING_DATED_TRIP" />
      </template>
      <div class="flex flex-col gap-4">
        <span>{{ t('pages.tripBooking.scheduleType.dated.description') }}</span>
        <ElRouterLink
          :disabled="!bookingEnabled"
          class="mt-2 md:mt-4"
          primary
          :data-cy="tripBookingPage.BOOKING_REQUEST_BUTTON_DATED"
          :to="{name: ROUTE_NAME_BOOKING_FORM_DATED }"
          @click="$emit('select', 'dated')"
        >
          {{ t('generic.bookDatedTrip') }}
        </ElRouterLink>
      </div>
    </BoxCard>
    <BoxCard
      padded
      :title="t('generic.regularTrip')"
    >
      <template #help>
        <ContextualHelp :help-id="CONTEXT_HELP_BOOKING_TEMPLATE_TRIP" />
      </template>
      <div class="flex flex-col gap-4">
        <span>{{ t('pages.tripBooking.scheduleType.regular.description') }}</span>
        <ElRouterLink
          :disabled="!bookingEnabled"
          primary
          :to="{ name: ROUTE_NAME_BOOKING_FORM_TEMPLATE }"
          class="mt-2 md:mt-4"
          :data-cy="tripBookingPage.BOOKING_REQUEST_BUTTON_TEMPLATE"
          @click="$emit('select', 'template')"
        >
          {{ t('generic.bookRegularTrip') }}
        </ElRouterLink>
      </div>
    </BoxCard>
  </div>
</template>
